import { VisuallyHidden } from 'tamagui';

export default VisuallyHidden;
